<template>
    <label>{{ $e('Choose date and time') }}</label>
    <flat-pickr v-model="trigger.scheduled_at" :config="{ enableTime: true, time_24hr: true, dateFormat: 'Y-m-d H:i' }" :placeholder="'Pick a date and time'" required></flat-pickr>
</template>

<script>

export default {
    components: {  },
    props: {
        trigger:  { type: Object, required: true }
    },
    methods: {

    }
}
</script>
